import {
  Alert,
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  LinearProgress,
  Stack,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getFacilityReport, submitReport } from '../../../../helpers/api';
import LoaderSkeleton from '../../../common/LoaderSkeleton';
import { Empty } from 'antd';
import StandardResultMeasurementInputs from './StandardResultMeasurementInputs';
import { Circle, PanoramaFishEye } from '@mui/icons-material';
import { openNotification } from '../../../../helpers/notification';
import { reportStatuses } from '../../../../helpers/appstate';
// import SubmitResult from './SubmitResult';
import { Link } from 'react-router-dom';
import RejectResult from '../../result/result-action/RejectResult';
import ApproveResult from '../../result/result-action/ApproveResult';
import SubmitResult from '../../result/result-action/SubmitResult';
import ResultComments from '../../result/result-action/ResultComments';

export default function StandardResultMeasurement({ props, report, onRefresh }) {
  const { userCategory, userPermission, userId } = props;

  const userPerm =
    userPermission && userPermission.length > 0
      ? userPermission.map((mp) => mp.trim().toLowerCase())
      : [];

  const canPublishResult = userPerm.includes('publish_report');

  const [reportExtention, setReportData] = useState();
  const [loading, setLoading] = useState(false);
  const [selectedSamplePoint, setSelectedSamplePoint] = useState();
  const [refresh, setRefresh] = useState(false);
  const [submitionDialog, setSubmitionDialog] = useState(false);
  const [openPublish, setOpenPublish] = useState(false);
  const [openReject, setOpenReject] = useState(false);
  const [openComment, setOpenComment] = useState(false);

  // console.log('report', report);
  // console.log('reportExtention', reportExtention);

  useEffect(() => {
    fetchReportExtention();
  }, []);

  useEffect(() => {
    if (refresh) {
      refreshReportExtention();
    }
  }, [refresh]);

  const fetchReportExtention = async () => {
    setLoading(true);
    try {
      const res = await getFacilityReport(
        report?.facilityId,
        report?.reportQuarter,
        report?.reportYear
      );
      const { data, status } = res?.result;
      if (status?.code === '00') {
        setReportData(data);

        if (!selectedSamplePoint) {
          setSelectedSamplePoint(data?.samplePoints[0]);
        }
      } else {
        openNotification({ type: 'error', message: status?.desc });
      }
    } catch (error) {
    } finally {
      setLoading(false);
      setRefresh(false);
    }
  };

  const refreshReportExtention = async () => {
    // setLoading(true);
    try {
      const res = await getFacilityReport(
        report?.facilityId,
        report?.reportQuarter,
        report?.reportYear
      );
      const { data, status } = res?.result;
      if (status?.code === '00') {
        setReportData(data);

        if (!selectedSamplePoint) {
          setSelectedSamplePoint(data?.samplePoints[0]);
        }
      } else {
        openNotification({ type: 'error', message: status?.desc });
      }
    } catch (error) {
    } finally {
      // setLoading(false);
      setRefresh(false);
    }
  };

  const getCheckCounts = (spItem) => {
    const checkCounts = [];
    for (let a = 1; a <= spItem?.checkCount; a++) {
      checkCounts.push(a);
    }
    return checkCounts;
  };

  const getResultCounts = (spItem) => {
    const resultCounts = [];
    for (let a = 1; a <= spItem?.resultCount; a++) {
      resultCounts.push(a);
    }
    return resultCounts;
  };

  const getProgressColor = () => {
    const p = reportExtention?.resultProgressPercentage || 0;

    // We switch on 'true' to evaluate ranges
    switch (true) {
      case p >= 100:
        return 'success'; // Green
      case p >= 50:
        return 'primary'; // Blue (or 'info')
      case p > 0:
        return 'warning'; // Orange
      default:
        return 'error'; // Red (0% or undefined)
    }
  };

  const handleRendering = () => {
    if (loading) {
      return (
        <Box sx={{ py: 1 }}>
          <LoaderSkeleton />
        </Box>
      );
    }

    if (!loading && !reportExtention) {
      return (
        <Box>
          <Empty />
        </Box>
      );
    }

    if (!loading && reportExtention) {
      return renderContent2();
    }
  };

  const renderContent2 = () => {
    return (
      <Box
        sx={{
          width: '100%',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(min(200px, 100%), 1fr))',
          gap: 2,
        }}
      >
        {reportExtention?.samplePoints?.map((item, index) => {
          const checkCounts = getCheckCounts(item);
          const resultCounts = getResultCounts(item);

          return (
            <Card
              key={index}
              sx={{ boxShadow: `0px 1px 1px rgba(0, 0, 0, 0.1), 0px 2px 10px rgba(0, 0, 0, 0.15)` }}
            >
              <CardActionArea
                onClick={() => setSelectedSamplePoint(item)}
                // reportExtention-active={
                //   item?.samplePointId === selectedSamplePoint?.samplePointId ? '' : undefined
                // }
                sx={{
                  height: '100%',
                  bgcolor:
                    item?.samplePointId === selectedSamplePoint?.samplePointId
                      ? 'primary.light'
                      : null,

                  // '&[reportExtention-active]': {
                  //   backgroundColor: 'primary.light',
                  //   '&:hover': {
                  //     backgroundColor: 'action.selectedHover',
                  //   },
                  // },
                }}
              >
                <CardContent sx={{ height: '100%' }}>
                  <Stack direction="row" alignItems={'center'}>
                    <Box>
                      {item?.icon && (
                        <img
                          src={item?.icon}
                          alt="icon"
                          style={{
                            objectFit: 'contain',
                            width: '30px',
                            height: '30px',
                          }}
                        />
                      )}
                    </Box>
                    <Box sx={{ ml: 'auto' }}>
                      {checkCounts?.map((checkCountitem) => {
                        const availableResults = resultCounts?.find((x) => x === checkCountitem);
                        if (availableResults) {
                          return <Circle color="success" fontSize="small" />;
                        } else {
                          return (
                            <PanoramaFishEye
                              color="disabled"
                              sx={{ bgcolor: '#fff', borderRadius: 50 }}
                              fontSize="small"
                            />
                          );
                        }
                      })}
                    </Box>
                  </Stack>
                  <Stack direction={'row'} spacing={1} alignItems={'center'}>
                    <Typography
                      variant="body1"
                      // component="div"
                      fontWeight={600}
                      color={
                        item?.samplePointId === selectedSamplePoint?.samplePointId
                          ? '#fff'
                          : 'textPrimary'
                      }
                    >
                      {item?.samplePointName}
                    </Typography>
                  </Stack>
                  <Typography
                    variant="body2"
                    color={
                      item?.samplePointId === selectedSamplePoint?.samplePointId
                        ? '#fff'
                        : 'textSecondary'
                    }
                    sx={{ textTransform: 'capitalize' }}
                  >
                    {item?.measurementName}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          );
        })}
      </Box>
    );
  };

  const renderRemarkButton = () => {
    const hasRemarks = reportExtention?.reportComments?.length > 0;
    return (
      <Box>
        {hasRemarks ? (
          <Button
            variant="text"
            size="small"
            color="primary"
            disableElevation
            sx={{ textTransform: 'none' }}
            onClick={() => setOpenComment(true)}
          >
            See Comments
          </Button>
        ) : null}
      </Box>
    );
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 3, alignItems: 'center' }}>
        <Box>
          <Link to={`/facilities/${report?.facilityId}/view`}>
            <Typography
              variant="h6"
              fontWeight={600}
              color="textPrimary"
              sx={{ '&:hover': { opacity: 0.7 } }}
            >
              {report?.facility}
            </Typography>
          </Link>
        </Box>
        <Box>
          <LinearProgress
            variant="determinate"
            color={getProgressColor()}
            value={Math.round(reportExtention?.resultProgressPercentage || 0)}
            sx={{ width: 200, height: 10 }}
          />
          <Typography variant="body2" color={getProgressColor()} sx={{ fontSize: '0.8rem' }}>
            {Math.round(reportExtention?.resultProgressPercentage || 0)}% Completion
          </Typography>
        </Box>
      </Box>

      {reportExtention?.reportStatus === reportStatuses.PUBLISHED && (
        <Alert
          severity="success"
          sx={{ mb: 3 }}
          action={
            <Stack direction="row" spacing={1}>
              {renderRemarkButton()}
            </Stack>
          }
        >
          <Typography variant="body2" fontWeight={600}>
            This result has been published and can no longer be editted
          </Typography>
        </Alert>
      )}

      {reportExtention?.reportStatus === reportStatuses.SUBMITTED && (
        <Alert
          severity="info"
          sx={{ mb: 3 }}
          action={
            <Stack direction="row" spacing={1}>
              {renderRemarkButton()}
              {canPublishResult && (
                <Stack direction="row" spacing={1}>
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    onClick={() => setOpenPublish(true)}
                    sx={{ textTransform: 'none', borderRadius: 1 }}
                  >
                    Approve
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={() => setOpenReject(true)}
                    sx={{ textTransform: 'none', borderRadius: 1 }}
                  >
                    Reject
                  </Button>
                </Stack>
              )}
            </Stack>
          }
        >
          <Typography variant="body2" fontWeight={600}>
            Result has been submitted and awaiting review
          </Typography>
        </Alert>
      )}

      {reportExtention?.submissionReady && reportExtention?.reportStatus === reportStatuses.DRAFT && (
        <Alert
          severity="warning"
          sx={{ mb: 3 }}
          action={
            <Stack direction="row" spacing={1}>
              {renderRemarkButton()}
              <Button
                variant="contained"
                color="warning"
                size="small"
                onClick={() => setSubmitionDialog(true)}
                sx={{ textTransform: 'none' }}
              >
                Submit
              </Button>
            </Stack>
          }
        >
          <Typography variant="body2" fontWeight={600}>
            Data collection has been completed. Submit this for review and approval
          </Typography>
        </Alert>
      )}

      {reportExtention?.reportStatus === reportStatuses.REJECTED && (
        <Alert
          severity="error"
          sx={{ mb: 3 }}
          action={
            <Stack direction="row" spacing={1}>
              {renderRemarkButton()}
              <Button
                variant="contained"
                color="warning"
                size="small"
                onClick={() => setSubmitionDialog(true)}
                sx={{ textTransform: 'none' }}
              >
                Resubmit
              </Button>
            </Stack>
          }
        >
          <Typography variant="body2" fontWeight={600}>
            Data collection was rejected by the approver. Please make the neccessary changes and
            resubmit for review
          </Typography>
        </Alert>
      )}

      <Box>{handleRendering()}</Box>
      <br />
      <Box>
        <StandardResultMeasurementInputs
          report={report}
          samplePoint={selectedSamplePoint}
          onRefresh={(currenetSamplePoint) => {
            setRefresh(true);
            setSelectedSamplePoint(currenetSamplePoint);
          }}
        />
      </Box>
      <br />

      {submitionDialog && (
        <SubmitResult
          open={submitReport}
          onClose={() => {
            setSubmitionDialog(false);
            onRefresh();
          }}
          reportId={report?.reportId}
          facilityId={report?.facilityId}
          reportQuarter={report?.reportQuarter}
          reportYear={report?.reportYear}
        />
      )}

      {openPublish && (
        <ApproveResult
          open={openPublish}
          title={'Approve Result'}
          onClose={() => {
            setOpenPublish(false);
            setRefresh(true);
          }}
          facilityId={report?.facilityId}
          reportQuarter={report?.reportQuarter}
          reportYear={report?.reportYear}
        />
      )}

      {openReject && (
        <RejectResult
          open={openReject}
          title={'Reject Result'}
          onClose={() => {
            setOpenReject(false);
            setRefresh(true);
          }}
          facilityId={report?.facilityId}
          reportQuarter={report?.reportQuarter}
          reportYear={report?.reportYear}
        />
      )}

      {openComment && (
        <ResultComments
          open={openComment}
          onClose={() => {
            setOpenComment(false);
            setRefresh(true);
          }}
          reportId={report?.reportId}
          facilityId={report?.facilityId}
          reportQuarter={report?.reportQuarter}
          reportYear={report?.reportYear}
          userId={userId}
        />
      )}
    </Box>
  );
}
